import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors as cartSelectors } from '@elab/core/store/cart';
import { getValueByStorePath } from '@elab/core/utils/helpers';

/**
 * Component shows current product information based on either product code or redux path to product code
 *
 * @attr {String} [product-code] - code of the product (e.g. MRN_97652)
 * @attr {String} [product-code-path] - path to product from redux (e.g. product.productCodeToBeRemoved)
 * @attr {String} [css-class] - class name for root element
 *
 * Parameters - comes from redux store:
 * @param {Object} product - produce object from cart entries
 *
 * Examples of usage:
 * <e2-product-info
 *  product-code="INT_TST_0002"
 * ></e2-product-info>
 *
 * <e2-product-info
 *  product-code-path="path.to.redux"
 * ></e2-product-info>
 */

export class ProductInfo extends LightLitElement {
    static get properties() {
        return {
            productCode: { type: String, attribute: 'product-code' },
            productCodePath: { type: String, attribute: 'product-code-path' },
            cssClass: { type: String, attribute: 'css-class' },
            product: { type: Object, attribute: false },
        };
    }

    render() {
        const { masterBrand = {}, rangeName = '', name = '' } = this.product || {};

        return html`
            <div
                class="product-info ${this.cssClass || ''} ${this.product
                    ? 'd-contents'
                    : 'd-none'}"
            >
                <span class="product-info__brand">${(masterBrand && masterBrand.name) || ''}</span>
                <span class="product-info__range">${rangeName}</span>
                <span class="product-info__name">
                    ${name} <v-slot name="after-name"></v-slot>
                </span>
            </div>
        `;
    }
}

const mapStateToProps = (state, ctx) => {
    const productCode = ctx.productCodePath
        ? getValueByStorePath(ctx.productCodePath, state)
        : ctx.productCode;

    if (!productCode) return {};
    const { product } = cartSelectors.getEntry(state, productCode) || {};

    return {
        product,
    };
};

export default () =>
    customElements.define('e2-product-info', connect(mapStateToProps)(ProductInfo));
